import { Expose } from '../serialization/class-transformer/decorators';
import { ServiceRequest } from './service-request';

export class StoreRequest<TModel> extends ServiceRequest {

  @Expose()
  model: TModel;
}
